export const WALLET_STATUS = {
	CONNECTING: 'connecting',
	RECONNECTING: 'reconnecting',
	CONNECTED: 'connected',
	DISCONNECTED: 'disconnected',
} as const

export type WalletStatus = (typeof WALLET_STATUS)[keyof typeof WALLET_STATUS]

export const WALLET_STATUS_LABELS = {
	[WALLET_STATUS.CONNECTING]: 'Loading wallet...',
	[WALLET_STATUS.RECONNECTING]: 'Loading wallet...',
	[WALLET_STATUS.CONNECTED]: 'Connected',
	[WALLET_STATUS.DISCONNECTED]: 'Disconnected',
} as const

export const isWalletLoading = (status: WalletStatus): boolean =>
	status === WALLET_STATUS.CONNECTING || status === WALLET_STATUS.RECONNECTING

export const isWalletConnected = (status: WalletStatus): boolean =>
	status === WALLET_STATUS.CONNECTED

export const isWalletDisconnected = (status: WalletStatus): boolean =>
	status === WALLET_STATUS.DISCONNECTED
